import { AfterViewInit, Directive, ElementRef, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[froalaView]',
  standalone: true,
})
export class FroalaViewDirective implements AfterViewInit {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  private selectors = ['p', 'ul'];

  ngAfterViewInit(): void {
    this.selectors.forEach((selector) => {
      const firstElement = this.el.nativeElement.querySelector(
        `.fr-view > ${selector}:first-child, .froala-matcher-v1 > ${selector}:first-child`,
      );
      const lastElement = this.el.nativeElement.querySelector(
        `.fr-view > ${selector}:last-child, .froala-matcher-v1 > ${selector}:last-child`,
      );

      if (firstElement) {
        this.renderer.setStyle(firstElement, 'margin-top', '0');
      }

      if (lastElement) {
        this.renderer.setStyle(lastElement, 'margin-bottom', '0');
      }
    });

    const editableSpans = this.el.nativeElement.querySelectorAll('span[contenteditable]');
    editableSpans.forEach((span: HTMLElement) => {
      this.renderer.setAttribute(span, 'contenteditable', 'false');
    });
  }
}
